import React from "react";

function PrivacyPolicy() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-14">
      <h2 className="mb-4 text-3xl font-semibold">Privacy Policy</h2>
      <p className="mb-6 text-gray-700">
        This Privacy Policy describes how FlashQuote AI collects, uses, and protects your personal information when you use our services.
      </p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">1. Information We Collect</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>Personal information such as name, email address, and contact details provided during registration.</li>
        <li>Usage data including interactions with our platform, device information, and IP address.</li>
        <li>Payment information for subscription and billing purposes.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">2. How We Use Your Information</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>To provide, maintain, and improve our services.</li>
        <li>To communicate with you regarding your account, updates, and support.</li>
        <li>To process payments and manage subscriptions.</li>
        <li>To ensure security and prevent fraud.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">3. Sharing Your Information</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>We do not sell your personal information.</li>
        <li>We may share information with trusted third-party service providers for payment processing, hosting, and analytics.</li>
        <li>We may disclose information if required by law or to protect our rights and users.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">4. Data Security</h3>
      <p className="text-gray-700">We implement industry-standard security measures to protect your data. However, no method of transmission or storage is completely secure.</p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">5. Your Rights</h3>
      <ul className="list-disc pl-6 text-gray-700">
        <li>You can access, update, or delete your personal information by contacting us.</li>
        <li>You may opt out of marketing communications at any time.</li>
      </ul>
      <h3 className="mt-6 mb-2 text-xl font-semibold">6. Changes to This Policy</h3>
      <p className="text-gray-700">We may update this Privacy Policy periodically. Changes will be posted on this page with the updated date.</p>
      <h3 className="mt-6 mb-2 text-xl font-semibold">7. Contact Us</h3>
      <p className="text-gray-700">If you have questions or concerns about this Privacy Policy, please contact us at flashquoteai@gmail.com.</p>
      <p className="mt-8 text-xs text-gray-500">Last updated: March 16, 2026</p>
    </div>
  );
}

export default PrivacyPolicy;
